import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Search18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.5 1.25C7.04822 1.25 4.25 4.04822 4.25 7.5C4.25 8.95563 4.74762 10.295 5.58202 11.3574L1.46973 15.4697L2.53039 16.5303L6.64269 12.418C7.70502 13.2524 9.0444 13.75 10.5 13.75C13.9518 13.75 16.75 10.9518 16.75 7.5C16.75 4.04822 13.9518 1.25 10.5 1.25ZM5.75 7.5C5.75 4.87665 7.87665 2.75 10.5 2.75C13.1234 2.75 15.25 4.87665 15.25 7.5C15.25 10.1234 13.1234 12.25 10.5 12.25C7.87665 12.25 5.75 10.1234 5.75 7.5Z'
      fill='currentColor'
    />
  </Svg>
);

Search18.displayName = 'Search18';
export default Search18;
